import './FooterSection.css';

const quickLinks = [
  { title: 'Fast Delivery', subtitle: 'Next working day delivery' },
  { title: 'Same Day Dispatch', subtitle: 'Weekdays by 5pm' },
  { title: 'Saturday Delivery', subtitle: 'Ask your rep about our saturday delivery' },
  { title: 'Bespoke Service', subtitle: 'Ask your rep for more info' },
];

const footerColumns = [
  {
    heading: 'Shop',
    links: ['New', 'Hot', 'Coming Soon'],
  },
  {
    heading: 'Vape News',
    links: ['The Rise In Nicotine Pouches', 'Legal Big Puff Devices', 'Vaping vs Smoking'],
  },
  {
    heading: 'Service',
    links: ['Contact Us', 'Refunds & Returns', 'Delivery Information', 'Careers'],
  },
  {
    heading: 'Legal',
    links: ['Terms & Conditions', 'Privacy Policy', 'Modern Slavery Statement'],
  },
];

function FooterSection() {
  return (
    <footer className="site-footer" aria-label="Footer">
      <div className="site-footer__main">
        <div className="site-footer__quick-grid">
          {quickLinks.map((item) => (
            <div key={item.title} className="site-footer__quick-item">
              <a href="/" onClick={(event) => event.preventDefault()}>
                {item.title}
              </a>
              <p>{item.subtitle}</p>
            </div>
          ))}
        </div>

        <hr className="site-footer__divider" />

        <div className="site-footer__link-grid">
          {footerColumns.map((column) => (
            <div key={column.heading} className="site-footer__link-col">
              <h3>{column.heading}</h3>
              {column.links.map((link) => (
                <a key={link} href="/" onClick={(event) => event.preventDefault()}>
                  {link}
                </a>
              ))}
            </div>
          ))}
        </div>

        <hr className="site-footer__divider" />

        <div className="site-footer__contact-row">
          <span>Phone: <strong>0121 663 1339</strong></span>
          <span className="site-footer__sep">|</span>
          <span>Hours: <strong>9:00AM to 5:00PM</strong></span>
          <span className="site-footer__sep">|</span>
          <span>E-mail: <strong>sales@vapesupplier.co.uk</strong></span>
          <span className="site-footer__sep">|</span>
          <a href="/" onClick={(event) => event.preventDefault()} aria-label="Facebook" className="site-footer__facebook">
            f
          </a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>
          You have to be over 18 to purchase from this website. Registered Office: VAPE SUPPLIER TM Ltd, 33
          Bennetts Hill, Birmingham, West Midlands, England, B2 5SN - Registered in England VAPE SUPPLIER TM Ltd
          UK Company Registration Number: 10873335, VAT Number: GB 272938666
        </p>
        <p>© 2026, Vape Supplier Ltd TM - All Rights Reserved</p>
      </div>
    </footer>
  );
}

export default FooterSection;
